import type { FaireProductEntity } from "../../entity_types/product";

export const p_c54rxyehcb: FaireProductEntity = {
  token: "p_c54rxyehcb",
  type: "product",
  name: "Golf Tee Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/db341dabbd1cb622bbd9b3a91ae4f66d6e7e131db4d74163276783a9c9852e9c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd8cf157846f15dcc6f18d28bd94c136ee36addbc968dd36182a26f028d8e450.jpeg",
    "https://cdn.faire.com/fastly/4a0aec0fb8c03d5272dcb8f49333c69d644eb655a8614bffeed078946070d8db.jpeg",
    "https://cdn.faire.com/fastly/4bd646e8a4deb6a4fc0884b9a89efbb3a95112f242100c49f49fff173c2eacc4.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:19.016Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
